import React from 'react'
import {PrivateNoteErrorMessageProperties} from "../../types/PrivateNoteErrorMessageProperties";

const PrivateNoteErrorMessage = ({errorMessage}: PrivateNoteErrorMessageProperties) => (
    errorMessage ?
        <div className="error-message-div">{errorMessage}</div> :
        null
)

export default PrivateNoteErrorMessage